import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const testimonials = [
  {
    img: "client-03.png",
    name: "Mr. Rajesh Yadav",
    location: "Mumbai",
    text: `"Royal Route Cab provided an excellent travel experience. The driver was punctual, polite, and the car was very clean. My airport drop was smooth and stress-free."`,
  },
  {
    img: "client-04.png",
    name: "Ms. Neha Joshi",
    location: "Pune",
    text: `"Very reliable cab service. I booked a family trip to Lonavala and the journey was comfortable and safe. Highly recommended for outstation travel."`,
  },
  {
    img: "client-03.png",
    name: "Mr. Suresh Patel",
    location: "Nashik",
    text: `"I regularly use Royal Route Cab for business travel. Always on time, professional drivers, and hassle-free booking. Great service overall."`,
  },
  {
    img: "client-04.png",
    name: "Ms. Pooja Deshmukh",
    location: "Kolhapur",
    text: `"Very smooth experience from booking to drop. Clean car, safe driving, and affordable pricing. Perfect for long-distance journeys."`,
  },
];

const Testimonialabout = () => {
  return (
    <section className="testimonial-section-4 section-padding">
      <div className="container">

        {/* Header */}
        <div className="section-title-area">
          <div className="section-title">
            <span className="wow fadeInUp">Customer Testimonials</span>

            <h2 className="wow fadeInUp text-dark" data-wow-delay=".3s text-dark">
              What Our Customers Say About <br /> Royal Route Cab
            </h2>
          </div>

       
        </div>

        {/* Slider */}
        <Swiper
          modules={[Autoplay]}
          spaceBetween={30}
          slidesPerView={2}
          loop={true}
          autoplay={{ delay: 2500 }}
          breakpoints={{
            320: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
          }}
        >
          {testimonials.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="testimonial-box-items-4">

                {/* Image */}
                <div className="testi-img">
                  {/* <img
                    src={`/img/testimonial/${item.img}`}
                    alt={item.name}
                  /> */}
                </div>

                {/* Stars */}
                <div className="star">⭐⭐⭐⭐⭐</div>

                {/* Quote Icon */}
                <div className="icon pt-5">
                  <img
                    src="/img/testimonial/quote-01.png"
                    alt="quote"
                  />
                </div>

                {/* Text */}
                <h3>{item.text}</h3>

                {/* Client Info */}
                <div className="client-info">
                  <h4>{item.name}</h4>
                  <span>from {item.location}</span>
                </div>

              </div>
            </SwiperSlide>
          ))}
        </Swiper>

      </div>
    </section>
  );
};

export default Testimonialabout;